/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPPRODUCT } from './IAPPRODUCT';
import {
    IAPPRODUCTFromJSON,
    IAPPRODUCTFromJSONTyped,
    IAPPRODUCTToJSON,
} from './IAPPRODUCT';

/**
 * 
 * @export
 * @interface PaymentDetailsCashTransferInvestmentViewModel
 */
export interface PaymentDetailsCashTransferInvestmentViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsCashTransferInvestmentViewModel
     */
    premiumId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsCashTransferInvestmentViewModel
     */
    premiumTransferAssetInvestmentId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsCashTransferInvestmentViewModel
     */
    providerId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsCashTransferInvestmentViewModel
     */
    assetCodeForCollectiveInvestment?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsCashTransferInvestmentViewModel
     */
    nameForCollectiveInvestment?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsCashTransferInvestmentViewModel
     */
    investmentNumber?: string;
    /**
     * 
     * @type {IAPPRODUCT}
     * @memberof PaymentDetailsCashTransferInvestmentViewModel
     */
    investmentNameId?: IAPPRODUCT;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsCashTransferInvestmentViewModel
     */
    estimatedAmount?: number;
}

/**
 * Check if a given object implements the PaymentDetailsCashTransferInvestmentViewModel interface.
 */
export function instanceOfPaymentDetailsCashTransferInvestmentViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaymentDetailsCashTransferInvestmentViewModelFromJSON(json: any): PaymentDetailsCashTransferInvestmentViewModel {
    return PaymentDetailsCashTransferInvestmentViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsCashTransferInvestmentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsCashTransferInvestmentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'premiumId': !exists(json, 'PremiumId') ? undefined : json['PremiumId'],
        'premiumTransferAssetInvestmentId': !exists(json, 'PremiumTransferAssetInvestmentId') ? undefined : json['PremiumTransferAssetInvestmentId'],
        'providerId': !exists(json, 'ProviderId') ? undefined : json['ProviderId'],
        'assetCodeForCollectiveInvestment': !exists(json, 'AssetCodeForCollectiveInvestment') ? undefined : json['AssetCodeForCollectiveInvestment'],
        'nameForCollectiveInvestment': !exists(json, 'NameForCollectiveInvestment') ? undefined : json['NameForCollectiveInvestment'],
        'investmentNumber': !exists(json, 'InvestmentNumber') ? undefined : json['InvestmentNumber'],
        'investmentNameId': !exists(json, 'InvestmentNameId') ? undefined : IAPPRODUCTFromJSON(json['InvestmentNameId']),
        'estimatedAmount': !exists(json, 'EstimatedAmount') ? undefined : json['EstimatedAmount'],
    };
}

export function PaymentDetailsCashTransferInvestmentViewModelToJSON(value?: PaymentDetailsCashTransferInvestmentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PremiumId': value.premiumId,
        'PremiumTransferAssetInvestmentId': value.premiumTransferAssetInvestmentId,
        'ProviderId': value.providerId,
        'AssetCodeForCollectiveInvestment': value.assetCodeForCollectiveInvestment,
        'NameForCollectiveInvestment': value.nameForCollectiveInvestment,
        'InvestmentNumber': value.investmentNumber,
        'InvestmentNameId': IAPPRODUCTToJSON(value.investmentNameId),
        'EstimatedAmount': value.estimatedAmount,
    };
}

